import * as Constants from "../common/Constants";
import * as Apis from "../common/ApiUrls"
import httpService from "../common/HttpService";
import { actionCreators as nAC } from "./NotificationActions";
import { Auth } from "../common/Common";
import { batch } from 'react-redux'


export const actionCreators = {
    requestLogin: (user, pass) => async (dispatch, getState) => {

        dispatch({ type: Constants.REQUEST_LOGIN });

        try {
            debugger;
            const response = await httpService.postJsonAsync(Apis.LOGIN, { userName: user, password: pass, allowedUserTypes: [1,5] }, false);
            const moduleResponse = await httpService.getAsync(Apis.CLIENT_MODULES, null, false, {"Authorization" : `bearer ${response.data.token}`});
            batch(() => {
                dispatch({ type: Constants.ACCEPT_LOGIN, authData: response.data });
                dispatch( {type: Constants.SET_CLIENT_MODULES, payload: moduleResponse.data});
            })
            
        } catch (e) {
            dispatch({ type: Constants.INVALID_LOGIN, error: e });
        }

    },

    requestRefreshToken: (token, refreshToken) => async (dispatch, getState) => {

        dispatch({ type: Constants.REQUEST_REFRESH_TOKEN });

        try {
            const response = await httpService.postJsonAsync(Apis.REFRESH_TOKEN, { token, refreshToken }, false);
            dispatch({ type: Constants.ACCEPT_REFRESH_TOKEN, authData: response.data });
        } catch (e) {
            dispatch({ type: Constants.INVALID_LOGIN, error: e });
        }
    },

    checkLogin: () => async (dispatch, getState) => {
        if (getState().isRefreshing || getState().isAuthorizing) {
            return;
        }
        
        try {
            var auth = getState().login.auth;
            if (auth) {
                let ex = new Date(auth.expiration);
                var isAuth = ex.getTime() > new Date().getTime();
                if (isAuth) {
                    if (!getState().login.clientModules) {
                        batch(() => {
                            dispatch({ type: Constants.HAS_LOGIN });
                            dispatch({ type: Constants.GET_CLIENT_MODULES })
                        })
                    } else {
                        dispatch({ type: Constants.HAS_LOGIN });
                    }
                } else {
                    dispatch({ type: Constants.REQUEST_REFRESH_TOKEN });

                    try {
                        const response = await httpService.postJsonAsync(Apis.REFRESH_TOKEN,
                            { token: auth.token, refreshToken: auth.refreshToken },
                            false);
                        const moduleResponse = await httpService.getAsync(Apis.CLIENT_MODULES, null, false, {"Authorization" : `bearer ${response.data.token}`});
                        batch(() => {
                            dispatch({ type: Constants.ACCEPT_REFRESH_TOKEN, authData: response.data });
                            dispatch( {type: Constants.SET_CLIENT_MODULES, payload: moduleResponse.data});
                        })
                        
                    } catch (e1) {
                        localStorage.removeItem(Constants.AUTH_DATA);
                        localStorage.removeItem(Constants.CLIENT_MODULES_DATA);
                        dispatch({ type: Constants.INVALID_LOGIN, error: e1 });
                    }
                }
            } else {
                dispatch({ type: Constants.NO_LOGIN, error: { message:"No Authorization Data" } });
            }
        } catch (e) {
            console.log(e);
            dispatch({ type: Constants.INVALID_LOGIN, error: e });
        } 
    },

    requestLogout: () => async (dispatch, getState) => {

        dispatch({ type: Constants.REQUEST_LOGOUT });

        try {
            const response = await httpService.postJsonAsync(Apis.LOGOUT, {});
            dispatch({ type: Constants.SUCCESS_LOGOUT, authData: response.data });
            localStorage.removeItem(Constants.CLIENT_MODULES_DATA);
        } catch (e) {
            dispatch({ type: Constants.SUCCESS_LOGOUT, error: e });
            localStorage.removeItem(Constants.CLIENT_MODULES_DATA);
        } finally {
            dispatch(nAC.showNotification({ message: "You are logged out successfully", type: "info", place: "tc" }));
        }

    },
    
    getClientModules: () => async (dispatch) => {
        dispatch({ type: Constants.GET_CLIENT_MODULES })
    },

    addRefreshHandler: (handler) => async (dispatch) => {
        dispatch({ type: Constants.ADD_REFRESH_HANDLER, payload: handler })
    }

    //requestSignup: (user) => async (dispatch, getState) => {

    //    dispatch({ type: Constants.REQUEST_SIGN_UP });

    //    try {
    //        const response = await httpService.postJsonAsync(Apis.SIGN_UP, user);
    //        dispatch({ type: Constants.SUCCESS_SIGN_UP, authData: response.data });
    //    } catch (e) {
    //        dispatch({ type: Constants.ERROR_SIGN_UP, error: e });
    //    }

    //}

};


// WEBPACK FOOTER //
// ./src/actions/LoginActions.js